export default import.meta.ROLLDOWN_FILE_URL_g_nbfpwhPcnh1zQ1euV2Yw